"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.StreamContextMenu = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importStar(require("react"));
const lucide_react_1 = require("lucide-react");
const StreamContextMenu = ({ participant, position, onClose, onStopWatching, isMuted, onToggleMute, volume, onVolumeChange, onPopOut, duckingEnabled, onToggleDucking, duckingStrength, onDuckingStrengthChange, currentQuality = 'auto', onQualityChange, }) => {
    const menuRef = (0, react_1.useRef)(null);
    const [showQualityMenu, setShowQualityMenu] = (0, react_1.useState)(false);
    const [adjustedPos, setAdjustedPos] = (0, react_1.useState)(position);
    // Position adjustments to prevent overflowing window bounds
    (0, react_1.useEffect)(() => {
        if (menuRef.current) {
            const rect = menuRef.current.getBoundingClientRect();
            let x = position.x;
            let y = position.y;
            if (x + rect.width > window.innerWidth) {
                x = window.innerWidth - rect.width - 12;
            }
            if (y + rect.height > window.innerHeight) {
                y = window.innerHeight - rect.height - 12;
            }
            setAdjustedPos({ x: Math.max(10, x), y: Math.max(10, y) });
        }
    }, [position]);
    // Click outside and escape handler
    (0, react_1.useEffect)(() => {
        const handleClickOutside = (e) => {
            if (menuRef.current && !menuRef.current.contains(e.target)) {
                onClose();
            }
        };
        const handleKeyDown = (e) => {
            if (e.key === 'Escape')
                onClose();
        };
        document.addEventListener('mousedown', handleClickOutside);
        document.addEventListener('keydown', handleKeyDown);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [onClose]);
    const qualities = [
        { key: 'auto', label: 'Otomatik (Ağ Uyarlamalı)' },
        { key: '1080p', label: '1080p • 60 FPS (FHD Ultra)' },
        { key: '720p', label: '720p • 30 FPS (HD Standart)' },
        { key: '480p', label: '480p • SD Kalite' },
        { key: '360p', label: '360p • Düşük Veri' },
    ];
    return ((0, jsx_runtime_1.jsxs)("div", { ref: menuRef, className: "discord-stream-context-menu", style: {
            position: 'fixed',
            top: adjustedPos.y,
            left: adjustedPos.x,
            zIndex: 9999999,
            background: '#2b2d31',
            border: '1px solid rgba(255, 255, 255, 0.08)',
            borderRadius: '8px',
            padding: '6px 8px',
            width: '260px',
            boxShadow: '0 16px 40px rgba(0, 0, 0, 0.75)',
            color: '#dbdee1',
            fontFamily: 'Inter, system-ui, -apple-system, sans-serif',
            userSelect: 'none',
            fontSize: '13px',
        }, onClick: (e) => e.stopPropagation(), children: [onStopWatching && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)("div", { onClick: () => {
                            onStopWatching();
                            onClose();
                        }, style: {
                            display: 'flex',
                            alignItems: 'center',
                            gap: '10px',
                            padding: '8px 10px',
                            borderRadius: '4px',
                            cursor: 'pointer',
                            color: '#dbdee1',
                            fontWeight: 500,
                            transition: 'background-color 0.1s',
                        }, onMouseEnter: (e) => {
                            e.currentTarget.style.backgroundColor = '#5865f2';
                            e.currentTarget.style.color = '#fff';
                        }, onMouseLeave: (e) => {
                            e.currentTarget.style.backgroundColor = 'transparent';
                            e.currentTarget.style.color = '#dbdee1';
                        }, children: [(0, jsx_runtime_1.jsx)(lucide_react_1.Square, { size: 16, style: { strokeWidth: 2.2 } }), (0, jsx_runtime_1.jsx)("span", { children: "\u0130zlemeyi B\u0131rak" })] }), (0, jsx_runtime_1.jsx)("div", { style: { height: '1px', background: 'rgba(255, 255, 255, 0.08)', margin: '4px 0' } })] })), (0, jsx_runtime_1.jsxs)("div", { onClick: () => {
                    onToggleMute();
                }, style: {
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    padding: '8px 10px',
                    borderRadius: '4px',
                    cursor: 'pointer',
                    color: '#dbdee1',
                    fontWeight: 500,
                    transition: 'background-color 0.1s',
                }, onMouseEnter: (e) => {
                    e.currentTarget.style.backgroundColor = '#35373c';
                }, onMouseLeave: (e) => {
                    e.currentTarget.style.backgroundColor = 'transparent';
                }, children: [(0, jsx_runtime_1.jsx)("span", { children: "Sustur" }), (0, jsx_runtime_1.jsx)("div", { style: {
                            width: '18px',
                            height: '18px',
                            borderRadius: '4px',
                            border: `2px solid ${isMuted ? '#5865f2' : '#80848e'}`,
                            background: isMuted ? '#5865f2' : 'transparent',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            transition: 'all 0.15s',
                        }, children: isMuted && (0, jsx_runtime_1.jsx)(lucide_react_1.Check, { size: 14, color: "#fff", strokeWidth: 3 }) })] }), (0, jsx_runtime_1.jsxs)("div", { style: { padding: '6px 10px 8px' }, children: [(0, jsx_runtime_1.jsxs)("div", { style: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '6px' }, children: [(0, jsx_runtime_1.jsx)("span", { style: { fontSize: '12px', fontWeight: 700, color: '#949ba4', textTransform: 'uppercase', letterSpacing: '0.4px' }, children: "YAYIN SES\u0130" }), (0, jsx_runtime_1.jsxs)("span", { style: { fontSize: '12px', fontWeight: 800, color: isMuted ? '#949ba4' : volume > 100 ? '#57f287' : '#fff' }, children: ["%", isMuted ? 0 : volume] })] }), (0, jsx_runtime_1.jsx)("input", { type: "range", min: "0", max: "200", value: isMuted ? 0 : volume, onChange: (e) => onVolumeChange(Number(e.target.value)), style: {
                            width: '100%',
                            accentColor: volume > 100 ? '#57f287' : '#5865f2',
                            cursor: 'pointer',
                            height: '6px',
                        } }), (0, jsx_runtime_1.jsxs)("div", { style: { display: 'flex', justifyContent: 'space-between', fontSize: '9px', color: '#80848e', marginTop: '2px' }, children: [(0, jsx_runtime_1.jsx)("span", { children: "%0" }), (0, jsx_runtime_1.jsx)("span", { children: "%100" }), (0, jsx_runtime_1.jsx)("span", { style: { color: '#57f287' }, children: "%200 Boost" })] })] }), (0, jsx_runtime_1.jsx)("div", { style: { height: '1px', background: 'rgba(255, 255, 255, 0.08)', margin: '4px 0' } }), onPopOut && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)("div", { onClick: () => {
                            onPopOut();
                            onClose();
                        }, style: {
                            display: 'flex',
                            alignItems: 'center',
                            gap: '10px',
                            padding: '8px 10px',
                            borderRadius: '4px',
                            cursor: 'pointer',
                            color: '#dbdee1',
                            fontWeight: 500,
                            transition: 'background-color 0.1s',
                        }, onMouseEnter: (e) => {
                            e.currentTarget.style.backgroundColor = '#5865f2';
                            e.currentTarget.style.color = '#fff';
                        }, onMouseLeave: (e) => {
                            e.currentTarget.style.backgroundColor = 'transparent';
                            e.currentTarget.style.color = '#dbdee1';
                        }, children: [(0, jsx_runtime_1.jsx)(lucide_react_1.ExternalLink, { size: 16 }), (0, jsx_runtime_1.jsx)("span", { children: "Yay\u0131n\u0131 Ayr\u0131 Pencereye Al" })] }), (0, jsx_runtime_1.jsx)("div", { style: { height: '1px', background: 'rgba(255, 255, 255, 0.08)', margin: '4px 0' } })] })), (0, jsx_runtime_1.jsxs)("div", { onClick: () => onToggleDucking(!duckingEnabled), style: {
                    display: 'flex',
                    flexDirection: 'column',
                    padding: '8px 10px',
                    borderRadius: '4px',
                    cursor: 'pointer',
                    transition: 'background-color 0.1s',
                }, onMouseEnter: (e) => {
                    e.currentTarget.style.backgroundColor = '#35373c';
                }, onMouseLeave: (e) => {
                    e.currentTarget.style.backgroundColor = 'transparent';
                }, children: [(0, jsx_runtime_1.jsxs)("div", { style: { display: 'flex', alignItems: 'center', justifyContent: 'space-between' }, children: [(0, jsx_runtime_1.jsx)("span", { style: { fontWeight: 500, color: '#dbdee1' }, children: "Yay\u0131n K\u0131sma" }), (0, jsx_runtime_1.jsx)("div", { style: {
                                    width: '18px',
                                    height: '18px',
                                    borderRadius: '4px',
                                    border: `2px solid ${duckingEnabled ? '#5865f2' : '#80848e'}`,
                                    background: duckingEnabled ? '#5865f2' : 'transparent',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    transition: 'all 0.15s',
                                }, children: duckingEnabled && (0, jsx_runtime_1.jsx)(lucide_react_1.Check, { size: 14, color: "#fff", strokeWidth: 3 }) })] }), (0, jsx_runtime_1.jsx)("span", { style: { fontSize: '11px', color: '#949ba4', marginTop: '4px', lineHeight: '1.3' }, children: "\u0130nsanlar konu\u015Furken yay\u0131n sesini otomatik olarak azalt." })] }), duckingEnabled && ((0, jsx_runtime_1.jsxs)("div", { style: { padding: '4px 10px 8px' }, children: [(0, jsx_runtime_1.jsxs)("div", { style: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '4px' }, children: [(0, jsx_runtime_1.jsx)("span", { style: { fontSize: '11px', fontWeight: 600, color: '#949ba4' }, children: "Yay\u0131n K\u0131sma G\u00FCc\u00FC" }), (0, jsx_runtime_1.jsxs)("span", { style: { fontSize: '11px', fontWeight: 700, color: '#fff' }, children: ["%", duckingStrength] })] }), (0, jsx_runtime_1.jsx)("input", { type: "range", min: "10", max: "100", value: duckingStrength, onChange: (e) => onDuckingStrengthChange(Number(e.target.value)), style: {
                            width: '100%',
                            accentColor: '#5865f2',
                            cursor: 'pointer',
                            height: '5px',
                        } })] })), (0, jsx_runtime_1.jsx)("div", { style: { height: '1px', background: 'rgba(255, 255, 255, 0.08)', margin: '4px 0' } }), (0, jsx_runtime_1.jsxs)("div", { style: { position: 'relative' }, children: [(0, jsx_runtime_1.jsxs)("div", { onClick: () => setShowQualityMenu(!showQualityMenu), style: {
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            padding: '8px 10px',
                            borderRadius: '4px',
                            cursor: 'pointer',
                            color: '#dbdee1',
                            fontWeight: 500,
                            transition: 'background-color 0.1s',
                        }, onMouseEnter: (e) => {
                            e.currentTarget.style.backgroundColor = '#35373c';
                            setShowQualityMenu(true);
                        }, children: [(0, jsx_runtime_1.jsx)("span", { children: "Daha Fazla Se\u00E7enek" }), (0, jsx_runtime_1.jsx)(lucide_react_1.ChevronRight, { size: 16, color: "#949ba4" })] }), showQualityMenu && ((0, jsx_runtime_1.jsxs)("div", { style: {
                            position: 'absolute',
                            left: '100%',
                            top: '-40px',
                            marginLeft: '4px',
                            background: '#2b2d31',
                            border: '1px solid rgba(255, 255, 255, 0.08)',
                            borderRadius: '8px',
                            padding: '6px',
                            width: '210px',
                            boxShadow: '0 12px 32px rgba(0, 0, 0, 0.75)',
                        }, onMouseLeave: () => setShowQualityMenu(false), children: [(0, jsx_runtime_1.jsx)("div", { style: { padding: '4px 8px 6px', fontSize: '11px', fontWeight: 700, color: '#949ba4', borderBottom: '1px solid rgba(255,255,255,0.06)', marginBottom: '4px' }, children: "YAYIN KAL\u0130TES\u0130" }), qualities.map((q) => ((0, jsx_runtime_1.jsxs)("div", { onClick: () => {
                                    onQualityChange?.(q.key);
                                    onClose();
                                }, style: {
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'space-between',
                                    padding: '7px 10px',
                                    borderRadius: '4px',
                                    cursor: 'pointer',
                                    color: currentQuality === q.key ? '#5865f2' : '#dbdee1',
                                    fontWeight: currentQuality === q.key ? 700 : 500,
                                    fontSize: '12px',
                                }, onMouseEnter: (e) => {
                                    e.currentTarget.style.backgroundColor = '#35373c';
                                }, onMouseLeave: (e) => {
                                    e.currentTarget.style.backgroundColor = 'transparent';
                                }, children: [(0, jsx_runtime_1.jsx)("span", { children: q.label }), currentQuality === q.key && (0, jsx_runtime_1.jsx)(lucide_react_1.Check, { size: 14, color: "#5865f2", strokeWidth: 3 })] }, q.key)))] }))] })] }));
};
exports.StreamContextMenu = StreamContextMenu;
